// This file is auto-generated during the compilation
// Its contents here do not resemble the actual localeMap present in the application
// The actual localeMap looks as follows:

// module.exports = {
//     en_US: () => [
//         import(/* webpackMode: "lazy", webpackChunkName: "en_US" */ '<...1>/i18n/en_US.json'),
//         import(/* webpackMode: "lazy", webpackChunkName: "en_US" */ '<...2>/i18n/en_US.json')
//     ]
// }

module.exports = {
    /** Contents of this object are auto-generated by `webpack-i18n-import-loader` */
    "en_US": function() { return [
import(/* webpackMode: "lazy", webpackChunkName: "en_US" */ '/opt/homebrew/var/www/shaamz/medisouqui/node_modules/@scandipwa/scandipwa/i18n/en_US.json')
] }
};
